import { render, staticRenderFns } from "./CUNopolTruck.vue?vue&type=template&id=4dc1a9c8&scoped=true"
import script from "./CUNopolTruck.vue?vue&type=script&lang=js"
export * from "./CUNopolTruck.vue?vue&type=script&lang=js"
import style0 from "./CUNopolTruck.vue?vue&type=style&index=0&id=4dc1a9c8&prod&lang=css"
import style1 from "./CUNopolTruck.vue?vue&type=style&index=1&id=4dc1a9c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc1a9c8",
  null
  
)

export default component.exports